module.exports = __webpack_public_path__ + "img/1_5.0136dda6.png";